import { render } from "./AddFriendGroupDialog.vue?vue&type=template&id=7546a846"
import script from "./AddFriendGroupDialog.vue?vue&type=script&lang=js"
export * from "./AddFriendGroupDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__